export function paramDeger(ek: any, ismi: string): any {
  const diziden = ek?.parametreler?.find((p: any) => p.ismi === ismi)?.degeri;
  if (diziden != null) return diziden;
  return ek?.[ismi] ?? '';
}

export function kutukGeo(en: number, boy: number, yuk: number) {
  const clamp = (v: number, lo: number, hi: number) => Math.min(Math.max(v, lo), hi);
  const w = clamp(en / 10 + 40, 40, 130), d = clamp(boy / 15 + 20, 20, 65), h = clamp(yuk / 12 + 25, 25, 95);
  const dh = d * .5;
  const vbW = 300, vbH = 150;
  const cx = vbW / 2 - (w + dh) / 2;
  const cy = vbH / 2 + (h + dh) / 2 + 5;
  return {
    enD: en ? en + ' mm' : 'X', boyD: boy ? boy + ' mm' : 'Y', yukD: yuk ? yuk + ' mm' : 'Z',
    w, d, h, dh, bx: cx, by: cy,
    vb: `0 0 ${vbW} ${vbH}`, mx: vbW / 2,
    ust: `${cx},${cy-h} ${cx+w},${cy-h} ${cx+w+dh},${cy-h-dh} ${cx+dh},${cy-h-dh}`,
    on: `${cx},${cy} ${cx+w},${cy} ${cx+w},${cy-h} ${cx},${cy-h}`,
    sag: `${cx+w},${cy} ${cx+w+dh},${cy-dh} ${cx+w+dh},${cy-dh-h} ${cx+w},${cy-h}`,
  };
}
